<template>
  <div class="home">
    <div class="totalWrap">
      <div class="headText">
        <div class="todayOrder" @click="openTodayOrderModal">
          <span class="todayOrder-text">금일 생산지시서</span>
        </div>
        <p class="crtData">실시간 데이터 표시</p>

        <!-- 금형 작업 컨트롤 -->
        <div class="moldControl" :class="{ 'moldControl--active': !!activeMold }">
          <div class="moldControl-inner">

            <!-- 자동완성 콤보박스 -->
            <div class="moldComboWrap" ref="moldComboWrap">
              <input
                v-model="moldSearchText"
                class="moldInput"
                type="text"
                placeholder="금형 선택 또는 입력..."
                :disabled="!!activeMold"
                autocomplete="off"
                @focus="showMoldDropdown = true"
                @blur="hideMoldDropdown"
              />
              <ul v-if="showMoldDropdown" class="moldDropdown">
                <li
                  v-if="filteredMoldList.length === 0"
                  class="moldDropdown-empty"
                >검색 결과 없음</li>
                <li
                  v-for="mold in filteredMoldList"
                  :key="mold.id"
                  class="moldDropdown-item"
                  :class="{ 'moldDropdown-item--selected': mold.id === selectedMoldId }"
                  @mousedown.prevent="selectMold(mold)"
                >{{ getMoldLabel(mold) }}</li>
              </ul>
            </div>

            <div class="moldBtns">
              <button
                class="moldBtn moldBtn-start"
                @click="startMoldWork"
                :disabled="!selectedMoldId || !!activeMold"
              >작업 시작</button>
              <button
                class="moldBtn moldBtn-end"
                @click="endMoldWork"
                :disabled="!activeMold"
              >작업 종료</button>
            </div>
          </div>
          <div v-if="activeMold" class="activeMoldBadge">
            <span class="activeMoldDot"></span>
            <span class="activeMoldText">진행 중: {{ activeMoldLabel }}</span>
          </div>
        </div>

      </div>

      <!-- 금일 생산지시서 모달 -->
      <div v-if="showOrderModal" class="order-modal-overlay" @click.self="showOrderModal = false">
        <div class="order-modal">
          <div class="order-modal-header">
            <span class="order-modal-title">생산지시서</span>
            <button class="order-modal-close" @click="showOrderModal = false">✕</button>
          </div>

          <div class="order-modal-body">
            <div v-if="orderLoading" class="order-modal-loading">불러오는 중...</div>
            <div v-else-if="orderNotFound" class="order-modal-empty">오늘 날짜의 생산지시서가 없습니다.</div>
            <template v-else>
              <div class="order-info-row">
                <div class="order-info-box">
                  <span class="order-info-label">작업날짜</span>
                  <span class="order-info-value">{{ orderPost.workDate }}</span>
                </div>
                <div class="order-info-box">
                  <span class="order-info-label">등록일</span>
                  <span class="order-info-value">{{ orderPost.insertTime }}</span>
                </div>
              </div>

              <div class="order-table-wrap">
                <table class="order-table">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>고객사</th>
                      <th>형번</th>
                      <th>재질</th>
                      <th>제품단중<br/><span class="sub">KG/M</span></th>
                      <th>제품중량<br/><span class="sub">KG</span></th>
                      <th>확정여부</th>
                      <th>제품길이<br/><span class="sub">MM</span></th>
                      <th>확정수량<br/><span class="sub">EA</span></th>
                      <th>확정수량<br/><span class="sub">KG</span></th>
                      <th>장빌렛<br/><span class="sub">(본)</span></th>
                      <th>등분수</th>
                      <th>단빌렛 길이</th>
                      <th>cycle 수</th>
                      <th>홀수</th>
                      <th>단빌렛<br/><span class="sub">EA</span></th>
                      <th>표면처리</th>
                      <th>납기</th>
                      <th>비고</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="orderPost.items.length === 0">
                      <td colspan="19" class="order-empty-row">등록된 항목이 없습니다.</td>
                    </tr>
                    <tr v-for="(row, idx) in orderPost.items" :key="idx">
                      <td>{{ idx + 1 }}</td>
                      <td>{{ row.customer }}</td>
                      <td>{{ row.modelNo }}</td>
                      <td>{{ row.material }}</td>
                      <td>{{ row.unitWeightKgM }}</td>
                      <td>{{ row.prodWeightKg }}</td>
                      <td>{{ row.confirmStatus }}</td>
                      <td>{{ row.prodLengthMm }}</td>
                      <td>{{ row.confirmQtyEa }}</td>
                      <td>{{ row.confirmQtyKg }}</td>
                      <td>{{ row.longBilletCnt }}</td>
                      <td>{{ row.divisionCnt }}</td>
                      <td>{{ row.singleBilletLength }}</td>
                      <td>{{ row.cycleCnt }}</td>
                      <td>{{ row.holeCnt }}</td>
                      <td>{{ row.singleBilletEa }}</td>
                      <td>{{ row.surfaceTreat }}</td>
                      <td>{{ row.dueDate }}</td>
                      <td>{{ row.remark }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="order-remark-box" v-if="orderPost.boardRemark">
                <span class="order-remark-label">비고</span>
                <span class="order-remark-text">{{ orderPost.boardRemark }}</span>
              </div>
            </template>
          </div>

          <div class="order-modal-footer">
            <button class="order-go-btn" @click="goProductionOrderPage">생산지시서 페이지로 이동</button>
            <button class="order-go-btn" @click="goWorkConditionPage">압출작업일보 페이지로 이동</button>
          </div>
        </div>
      </div>

      <!-- =======================
           TOP SECTION (4 cards)
           6-col grid 기준:
           - 현장환경 1칸
           - 빌렛예열 2칸
           - 압출    1칸
           - 퀜칭    2칸
      ======================= -->
      <div class="topSection">
        <!-- 현장 환경 -->
        <div class="card cardPurple fieldEnv">
          <p class="title">현장 환경</p>

          <div class="gaugeGrid gaugeGrid-1">
            <GaugeChart
              :value="fieldTem"
              label="온도"
              :labelTop="true"
              :min="fieldTemMin"
              :max="fieldTemMax"
              :thresholdMin="fieldTemMin"
              :thresholdMax="fieldTemMax"
              unit="℃"
              :bands="[
                { to: fieldTemLowDanger, color: '#d01919' },
                { to: fieldTemLowWarn,   color: '#ffa800' },
                { to: fieldTemWarn,      color: '#8bfd82' },
                { to: fieldTemDanger,    color: '#ffa800' },
                { to: fieldTemMax,       color: '#d01919' }
              ]"
              :useYn="fieldTemUseYn"
              class="gaugeItem"
            />

            <GaugeChart
              :value="fieldHum"
              label="습도"
              :labelTop="true"
              :min="fieldHumMin"
              :max="fieldHumMax"
              :thresholdMin="fieldHumMin"
              :thresholdMax="fieldHumMax"
              unit="%"
              :bands="[
                { to: fieldHumLowDanger, color: '#d01919' },
                { to: fieldHumLowWarn,   color: '#ffa800' },
                { to: fieldHumWarn,      color: '#8bfd82' },
                { to: fieldHumDanger,    color: '#ffa800' },
                { to: fieldHumMax,       color: '#d01919' }
              ]"
              :useYn="fieldHumUseYn"
              class="gaugeItem"
            />
          </div>
        </div>

        <!-- 빌렛예열온도 -->
        <div class="card cardPurple billetInsert">
          <p class="title">빌렛예열온도 <span class="workState">({{ isBilletWork }})</span><span class="workState">({{ isDoorOpen }})</span></p>

          <div class="gaugeGrid gaugeGrid-2">
            <GaugeChart
              :value="billetPreheatRead4"
              label="Zone 4"
              :labelTop="true"
              :min="0"
              :max="550"
              :thresholdMin="0"
              :thresholdMax="550"
              detailMode="billet"
              unit="℃"
              :bands="[
                { to: billetPreheatSet4, color: '#ffa800' },
                { to: 550, color: '#8bfd82' }
              ]"
              class="gaugeItem"
            />

            <GaugeChart
              :value="billetPreheatRead3"
              label="Zone 3"
              :labelTop="true"
              :min="0"
              :max="550"
              :thresholdMin="0"
              :thresholdMax="550"
              detailMode="billet"
              unit="℃"
              :bands="[
                { to: billetPreheatSet3, color: '#ffa800' },
                { to: 550, color: '#8bfd82' }
              ]"
              class="gaugeItem"
            />

            <GaugeChart
              :value="billetPreheatRead2"
              label="Zone 2"
              :labelTop="true"
              :min="0"
              :max="500"
              :thresholdMin="0"
              :thresholdMax="500"
              detailMode="billet"
              unit="℃"
              :bands="[
                { to: billetPreheatSet2, color: '#ffa800' },
                { to: 500, color: '#8bfd82' }
              ]"
              class="gaugeItem"
            />

            <GaugeChart
              :value="billetPreheatRead1"
              label="Zone 1"
              :labelTop="true"
              :min="0"
              :max="350"
              :thresholdMin="0"
              :thresholdMax="350"
              detailMode="billet"
              unit="℃"
              :bands="[
                { to: billetPreheatSet1, color: '#ffa800' },
                { to: 350, color: '#8bfd82' }
              ]"
              class="gaugeItem"
            />
          </div>
        </div>

        <!-- 압출 -->
        <div class="card cardPurple extrusion">
          <p class="title">압출</p>

          <div class="gaugeGrid gaugeGrid-1">
            <GaugeChart
              :value="extrusion"
              label="출구온도"
              :labelTop="true"
              :min="extrusionMin"
              :max="extrusionMax"
              :thresholdMin="extrusionMin"
              :thresholdMax="extrusionMax"
              unit="℃"
              :bands="[
                { to: extrusionLowDanger, color: '#d01919' },
                { to: extrusionLowWarn,   color: '#ffa800' },
                { to: extrusionWarn,      color: '#8bfd82' },
                { to: extrusionDanger,    color: '#ffa800' },
                { to: extrusionMax,       color: '#d01919' }
              ]"
              :useYn="extrusionUseYn"
              class="gaugeItem"
            >
              <template #label-extra>
                <button
                  class="mute-btn"
                  :title="lampMuted ? '경광등 소리 켜기' : '경광등 소리 끄기'"
                  @click="toggleLampMute"
                >
                  <img :src="lampMuted ? muteIcon : soundIcon" alt="mute toggle" />
                </button>
              </template>
            </GaugeChart>
            <GaugeChart
              :value="extrusionPressure"
              label="압력"
              :labelTop="true"
              :min="extrusionPressureMin"
              :max="extrusionPressureMax"
              :thresholdMin="extrusionPressureMin"
              :thresholdMax="extrusionPressureMax"
              unit="bar"
              :bands="[
                { to: extrusionPressureLowDanger, color: '#d01919' },
                { to: extrusionPressureLowWarn,   color: '#ffa800' },
                { to: extrusionPressureWarn,      color: '#8bfd82' },
                { to: extrusionPressureDanger,    color: '#ffa800' },
                { to: extrusionPressureMax,       color: '#d01919' }
              ]"
              :useYn="extrusionPressureUseYn"
              class="gaugeItem"
            />
            <GaugeChart
              :value="extrusionSpeed"
              label="RAM Speed"
              :subLabel="extrusionSetSpeed"
              :labelTop="true"
              :min="extrusionSpeedMin"
              :max="extrusionSpeedMax"
              :thresholdMin="extrusionSpeedMin"
              :thresholdMax="extrusionSpeedMax"
              unit="mm/s"
              :bands="[
                { to: extrusionSpeedLowDanger, color: '#d01919' },
                { to: extrusionSpeedLowWarn,   color: '#ffa800' },
                { to: extrusionSpeedWarn,      color: '#8bfd82' },
                { to: extrusionSpeedDanger,    color: '#ffa800' },
                { to: extrusionSpeedMax,       color: '#d01919' }
              ]"
              :useYn="extrusionSpeedUseYn"
              class="gaugeItem"
            />
          </div>
        </div>

        <!-- 퀜칭 -->
        <div class="card cardPurple quenching">
          <p class="title">퀜칭</p>

          <div class="gaugeGrid gaugeGrid-2">
            <GaugeChart
              :value="quenching1"
              label="물탱크 냉각전 온도"
              :labelTop="true"
              :min="quenching1Min"
              :max="quenching1Max"
              :thresholdMin="quenching1Min"
              :thresholdMax="quenching1Max"
              unit="℃"
              :bands="[
                { to: quenching1LowDanger, color: '#d01919' },
                { to: quenching1LowWarn,   color: '#ffa800' },
                { to: quenching1Warn,      color: '#8bfd82' },
                { to: quenching1Danger,    color: '#ffa800' },
                { to: quenching1Max,       color: '#d01919' }
              ]"
              :useYn="quenching1UseYn"
              class="gaugeItem"
            />

            <GaugeChart
              :value="quenching2"
              label="물탱크 냉각후 온도"
              :labelTop="true"
              :min="quenching2Min"
              :max="quenching2Max"
              :thresholdMin="quenching2Min"
              :thresholdMax="quenching2Max"
              unit="℃"
              :bands="[
                { to: quenching2LowDanger, color: '#d01919' },
                { to: quenching2LowWarn,   color: '#ffa800' },
                { to: quenching2Warn,      color: '#8bfd82' },
                { to: quenching2Danger,    color: '#ffa800' },
                { to: quenching2Max,       color: '#d01919' }
              ]"
              :useYn="quenching2UseYn"
              class="gaugeItem"
            />

            <GaugeChart
              :value="quenchLevel"
              label="퀜칭수위"
              :labelTop="true"
              :min="quenchLevelMin"
              :max="quenchLevelMax"
              :thresholdMin="quenchLevelMin"
              :thresholdMax="quenchLevelMax"
              unit="mm"
              :bands="[
                { to: quenchLevelLowDanger, color: '#d01919' },
                { to: quenchLevelLowWarn,   color: '#ffa800' },
                { to: quenchLevelWarn,      color: '#8bfd82' },
                { to: quenchLevelDanger,    color: '#ffa800' },
                { to: quenchLevelMax,       color: '#d01919' }
              ]"
              :useYn="quenchLevelUseYn"
              class="gaugeItem"
            />

            <GaugeChart
              :value="quenching3"
              label="퀜칭온도"
              :labelTop="true"
              :min="quenching3Min"
              :max="quenching3Max"
              :thresholdMin="quenching3Min"
              :thresholdMax="quenching3Max"
              unit="℃"
              :bands="[
                { to: quenching3LowDanger, color: '#d01919' },
                { to: quenching3LowWarn,   color: '#ffa800' },
                { to: quenching3Warn,      color: '#8bfd82' },
                { to: quenching3Danger,    color: '#ffa800' },
                { to: quenching3Max,       color: '#d01919' }
              ]"
              :useYn="quenching3UseYn"
              class="gaugeItem"
            />
          </div>
        </div>
      </div>

      <!-- =======================
           LOWER SECTION (3 cards)
           6-col grid 기준:
           - 퀜칭후 제품온도 3칸
           - 스트레칭       1칸
           - 열처리         2칸 (스트레칭 우측)
      ======================= -->
      <div class="lowerSection">
        <!-- 퀜칭 후 제품 온도 -->
        <div class="card quenchAfter">
          <p class="title">퀜칭 후 제품 온도</p>

          <div class="gaugeGrid gaugeGrid-3">
            <GaugeChart
              :value="quenchAfter2"
              label="퀜칭 후 온도"
              :labelTop="true"
              :min="quenchAfter2Min"
              :max="quenchAfter2Max"
              :thresholdMin="quenchAfter2Min"
              :thresholdMax="quenchAfter2Max"
              unit="℃"
              :bands="[
                { to: quenchAfter2LowDanger, color: '#d01919' },
                { to: quenchAfter2LowWarn,   color: '#ffa800' },
                { to: quenchAfter2Warn,      color: '#8bfd82' },
                { to: quenchAfter2Danger,    color: '#ffa800' },
                { to: quenchAfter2Max,       color: '#d01919' }
              ]"
              :useYn="quenchAfter2UseYn"
              class="gaugeItem"
            />

            <GaugeChart
              :value="quenchAfter1"
              label="테이블 온도"
              :labelTop="true"
              :min="quenchAfter1Min"
              :max="quenchAfter1Max"
              :thresholdMin="quenchAfter1Min"
              :thresholdMax="quenchAfter1Max"
              unit="℃"
              :bands="[
                { to: quenchAfter1LowDanger, color: '#d01919' },
                { to: quenchAfter1LowWarn,   color: '#ffa800' },
                { to: quenchAfter1Warn,      color: '#8bfd82' },
                { to: quenchAfter1Danger,    color: '#ffa800' },
                { to: quenchAfter1Max,       color: '#d01919' }
              ]"
              :useYn="quenchAfter1UseYn"
              class="gaugeItem"
            />

            <GaugeChart
              :value="quenchAfter3"
              label="스트레칭 전 온도"
              :labelTop="true"
              :min="quenchAfter3Min"
              :max="quenchAfter3Max"
              :thresholdMin="quenchAfter3Min"
              :thresholdMax="quenchAfter3Max"
              unit="℃"
              :bands="[
                { to: quenchAfter3LowDanger, color: '#d01919' },
                { to: quenchAfter3LowWarn,   color: '#ffa800' },
                { to: quenchAfter3Warn,      color: '#8bfd82' },
                { to: quenchAfter3Danger,    color: '#ffa800' },
                { to: quenchAfter3Max,       color: '#d01919' }
              ]"
              :useYn="quenchAfter3UseYn"
              class="gaugeItem"
            />
          </div>
        </div>

        <!-- 스트레칭 -->
        <div class="card stretching">
          <p class="title">스트레칭</p>

          <div class="gaugeGrid gaugeGrid-1">
            <GaugeChart
              :value="stretching"
              label="스트레칭"
              :labelTop="true"
              :min="stretchingMin"
              :max="stretchingMax"
              :thresholdMin="stretchingMin"
              :thresholdMax="stretchingMax"
              unit="cm"
              :bands="[
                { to: stretchingLowDanger, color: '#d01919' },
                { to: stretchingLowWarn,   color: '#ffa800' },
                { to: stretchingWarn,      color: '#8bfd82' },
                { to: stretchingDanger,    color: '#ffa800' },
                { to: stretchingMax,       color: '#d01919' }
              ]"
              :useYn="stretchingUseYn"
              class="gaugeItem"
            />
          </div>
        </div>

        <!-- 열처리 (스트레칭 우측, 2칸) -->
        <div class="card heatTreatment">
          <p class="title">열처리 <span class="workState">({{ isHeatTreatWork }})</span></p>

          <div class="heatList">
            <!-- <p class="valueTxt">열처리설정값 1 : {{ heatTreatSet1 }}℃</p> -->
            <p class="valueTxt heatTreatSetting">열처리설정값 <br /> <span class="valuePoint">{{ heatTreatSet2 }}℃</span></p>
            <div class="heatListChild">
              <div class="heatTreatReadTop">
                <p class="valueTxt heatTreatValue">열처리 1 <br /> <span class="valuePoint">{{ heatTreatRead1 }}℃</span></p>
                <p class="valueTxt heatTreatValue">열처리 2 <br /> <span class="valuePoint">{{ heatTreatRead1 }}℃</span></p>
                <p class="valueTxt heatTreatValue">열처리 3 <br /> <span class="valuePoint">{{ heatTreatRead1 }}℃</span></p>
              </div>
              <div class="heatTreatReadBottom">
                <p class="valueTxt heatTreatValue">열처리 4 <br /> <span class="valuePoint">{{ heatTreatRead2 }}℃</span></p>
                <p class="valueTxt heatTreatValue">열처리 5 <br /> <span class="valuePoint">{{ heatTreatRead2 }}℃</span></p>
                <p class="valueTxt heatTreatValue">열처리 6 <br /> <span class="valuePoint">{{ heatTreatRead2 }}℃</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import axios from 'axios'
/* eslint-disable */

import Stomp from 'webstomp-client'
import SockJS from 'sockjs-client'
import { mapState } from 'vuex';
import { EventBus } from '@/eventBus.js';
import GaugeChart from "@/components/GaugeChart.vue";

export default {
  name: "HomeView",
  data() {
    return {
      showOrderModal: false,
      orderLoading: false,
      orderNotFound: false,
      orderPost: { workDate: "", insertTime: "", boardRemark: "", items: [] },
      moldList: [],
      duplicateMoldNames: new Set(),
      selectedMoldId: '',
      moldSearchText: '',
      showMoldDropdown: false,
      activeMold: null,
      tableData: [],
      app: 0,
      pollDelay: 1000,   // 1초마다 요청 (300ms는 너무 짧아 서버에 부하될 수 있음)
      timerId: null,
      html: "",
      error: false,
      target: 0,
      ambient: 0,
      signal: 0,
      stomp: null,
      resMsg: '메시지 아직 안 옴',
      roomId: null,
      fieldTem: 0,   //현장온도
      fieldHum: 0,   //현장습도
      extrusion: 0,   //압출온도(extp)

      /* 경광등 부저 뮤트 */
      lampMuted: false,
      soundIcon: require('@/assets/image/sound.png'),
      muteIcon: require('@/assets/image/mute.png'),
      quenching1: 0,    //퀜칭온도1(qutp1)
      quenching2: 0,    //퀜칭온도2(qutp2)
      quenching3: 0,    //퀜칭온도3(qutp3)
      heatTreatRead1: 0,    //열처리측정값1(heatMs.xgtH1)
      heatTreatRead2: 0,    //열처리측정값2(heatMs.xgtH2)
      heatTreatSet1: 0,    //열처리설정값1(heatMs.xgtT1)
      heatTreatSet2: 0,    //열처리설정값2(heatMs.xgtT2)
      fieldEnv: 0,    //현장온습도
      stretching: 0,    //스트레칭
      quenchAfter1: 0,    //퀜칭후온도1(qutable)
      quenchAfter2: 0,    //퀜칭후온도2(quafter)
      quenchAfter3: 0,    //퀜칭후온도3(before)
      extrusionSpeed: 0,    //압출속도
      quenchLevel: 0,   //퀜칭수위
      billetPreheatRead1: 0,   //빌렛예열 측정치
      billetPreheatRead2: 0,   //빌렛예열 측정치
      billetPreheatRead3: 0,   //빌렛예열 측정치
      billetPreheatRead4: 0,   //빌렛예열 측정치
      billetPreheatSet1: 0,   //빌렛예열 설정값
      billetPreheatSet2: 0,   //빌렛예열 설정값
      billetPreheatSet3: 0,   //빌렛예열 설정값
      billetPreheatSet4: 0,   //빌렛예열 설정값

      // 현장온도
      fieldTemMin: 0,
      fieldTemLowDanger: 0,
      fieldTemLowWarn: 0,
      fieldTemWarn: 0,
      fieldTemDanger: 0,
      fieldTemMax: 0,
      fieldTemUseYn: '',

      // 현장습도
      fieldHumMin: 0,
      fieldHumLowDanger: 0,
      fieldHumLowWarn: 0,
      fieldHumWarn: 0,
      fieldHumDanger: 0,
      fieldHumMax: 0,
      fieldHumUseYn: '',

      // 압출온도 (EXTRUSION)
      extrusionMin: 0,
      extrusionLowDanger: 0,
      extrusionLowWarn: 0,
      extrusionWarn: 0,
      extrusionDanger: 0,
      extrusionMax: 0,
      extrusionUseYn: '',

      // 압출압력 (EXTRUSION_PRESSURE)
      extrusionPressureMin: 0,
      extrusionPressureLowDanger: 0,
      extrusionPressureLowWarn: 0,
      extrusionPressureWarn: 0,
      extrusionPressureDanger: 0,
      extrusionPressureMax: 0,
      extrusionPressureUseYn: 'Y',

      // 퀜칭온도1 (QUENCHING_1)
      quenching1Min: 0,
      quenching1LowDanger: 0,
      quenching1LowWarn: 0,
      quenching1Warn: 0,
      quenching1Danger: 0,
      quenching1Max: 0,
      quenching1UseYn: '',

      // 퀜칭온도2 (QUENCHING_2)
      quenching2Min: 0,
      quenching2LowDanger: 0,
      quenching2LowWarn: 0,
      quenching2Warn: 0,
      quenching2Danger: 0,
      quenching2Max: 0,
      quenching2UseYn: '',

      // 퀜칭온도3 (QUENCHING_3)
      quenching3Min: 0,
      quenching3LowDanger: 0,
      quenching3LowWarn: 0,
      quenching3Warn: 0,
      quenching3Danger: 0,
      quenching3Max: 0,
      quenching3UseYn: '',

      // 스트레칭 (STRETCHING)
      stretchingMin: 0,
      stretchingLowDanger: 0,
      stretchingLowWarn: 0,
      stretchingWarn: 0,
      stretchingDanger: 0,
      stretchingMax: 0,
      stretchingUseYn: '',

      // 퀜칭후온도1 (QUENCH_AFTER_1)
      quenchAfter1Min: 0,
      quenchAfter1LowDanger: 0,
      quenchAfter1LowWarn: 0,
      quenchAfter1Warn: 0,
      quenchAfter1Danger: 0,
      quenchAfter1Max: 0,
      quenchAfter1UseYn: '',

      // 퀜칭후온도2 (QUENCH_AFTER_2)
      quenchAfter2Min: 0,
      quenchAfter2LowDanger: 0,
      quenchAfter2LowWarn: 0,
      quenchAfter2Warn: 0,
      quenchAfter2Danger: 0,
      quenchAfter2Max: 0,
      quenchAfter2UseYn: '',

      // 퀜칭후온도3 (QUENCH_AFTER_3)
      quenchAfter3Min: 0,
      quenchAfter3LowDanger: 0,
      quenchAfter3LowWarn: 0,
      quenchAfter3Warn: 0,
      quenchAfter3Danger: 0,
      quenchAfter3Max: 0,
      quenchAfter3UseYn: '',

      // 압출속도 (EXTRUSION_SPEED)
      extrusionSpeedMin: 0,
      extrusionSpeedLowDanger: 0,
      extrusionSpeedLowWarn: 0,
      extrusionSpeedWarn: 0,
      extrusionSpeedDanger: 0,
      extrusionSpeedMax: 0,
      extrusionSpeedUseYn: '',

      // 퀜칭수위 (QUENCH_LEVEL)
      quenchLevelMin: 0,
      quenchLevelLowDanger: 0,
      quenchLevelLowWarn: 0,
      quenchLevelWarn: 0,
      quenchLevelDanger: 0,
      quenchLevelMax: 0,
      quenchLevelUseYn: '',

      extrusionPressure: 0,
      extrusionSetSpeed: 0,
      billetWork: 0,
      doorOpen: 0,
      heatTreatWork: 0,
    };
  },
  components: {
    GaugeChart
  },
  computed: {
    ...mapState({
      common: state => state.common,
      sensor: state => state.sensor.sensorInfo
    }),
    filteredMoldList() {
      if (!this.moldSearchText) return this.moldList;
      const q = this.moldSearchText.toLowerCase();
      return this.moldList.filter(m =>
        (m.moldName && m.moldName.toLowerCase().includes(q)) ||
        (m.moldNum  && m.moldNum.toLowerCase().includes(q))
      );
    },
    activeMoldLabel() {
      if (!this.activeMold) return '';
      // 백엔드 getActiveMold가 JOIN으로 MOLD_NAME을 직접 내려줌
      if (this.activeMold.moldName) return this.activeMold.moldName;
      // 폴백: moldList에서 찾기
      const found = this.moldList.find(m => m.id === this.activeMold.prodId);
      if (found) return this.getMoldLabel(found);
      return '';
    },
    isBilletWork() {
      if(this.billetWork) {
        return "가동 중"
      }else {
        return "가동 중지"
      }
    },
    isDoorOpen() {
      if(this.doorOpen) {
        return "Open"
      }else {
        return "Close"
      }
    },
    isHeatTreatWork() {
      if(this.heatTreatWork) {
        return "가동 중"
      }else {
        return "가동 중지"
      }
    }
  },
  watch: {
    moldSearchText(val) {
      const selected = this.moldList.find(m => m.id === this.selectedMoldId);
      if (selected && this.getMoldLabel(selected) === val) return;
      this.selectedMoldId = '';
    }
  },
  created() {
    EventBus.$on('disconnect', this.disconnect);
    EventBus.$on('connect', this.connect);
  },
  methods: {
    /* ── 경광등 부저 뮤트 ── */
    fetchLampMute() {
      this.$server.get('/getLampMute')
        .then((res) => { this.lampMuted = !!(res.data && res.data.muted); })
        .catch((err) => console.error('뮤트 상태 조회 실패:', err.message || err));
    },
    toggleLampMute() {
      const next = !this.lampMuted;
      this.$server.put('/setLampMute', null, { params: { muted: next } })
        .then((res) => { this.lampMuted = !!(res.data && res.data.muted); })
        .catch((err) => { console.error(err); alert('뮤트 변경 중 오류가 발생했습니다.'); });
    },

    getMoldLabel(mold) {
      return this.duplicateMoldNames.has(mold.moldName)
        ? `${mold.moldName} / ${mold.moldNum}`
        : mold.moldName;
    },
    hideMoldDropdown() {
      setTimeout(() => { this.showMoldDropdown = false; }, 150);
    },
    selectMold(mold) {
      this.selectedMoldId = mold.id;
      this.moldSearchText = this.getMoldLabel(mold);
      this.showMoldDropdown = false;
    },
    async loadMoldList() {
      try {
        const res = await this.$server.get('/getMoldNumList');
        this.moldList = (res.data && res.data.result) || [];
        const counts = {};
        this.moldList.forEach(m => { counts[m.moldName] = (counts[m.moldName] || 0) + 1; });
        this.duplicateMoldNames = new Set(Object.keys(counts).filter(k => counts[k] > 1));
      } catch (e) {
        console.error('금형 목록 로드 실패:', e);
      }
    },
    async loadActiveMold() {
      try {
        const res = await this.$server.get('/getActiveMold');
        this.activeMold = (res.data && res.data.result) || null;
        if (this.activeMold) {
          this.selectedMoldId = this.activeMold.prodId;
          const found = this.moldList.find(m => m.id === this.activeMold.prodId);
          if (found) this.moldSearchText = this.getMoldLabel(found);
        }
      } catch (e) {
        console.error('진행 중 금형 로드 실패:', e);
      }
    },
    async startMoldWork() {
      if (!this.selectedMoldId) return;
      const now = new Date();
      const pad = n => String(n).padStart(2, '0');
      const onTime = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
      try {
        const res = await this.$server.post('/saveMold', {
          prodId: this.selectedMoldId,
          onTime: onTime,
          offTime: null,
          billetLotNo: ''
        });
        if (res.data && typeof res.data !== 'object') {
          alert(`작업 시작 실패: ${res.data}`);
          return;
        }
        await this.loadActiveMold();
      } catch (e) {
        alert('작업 시작에 실패했습니다.');
        console.error(e);
      }
    },
    async endMoldWork() {
      if (!this.activeMold) return;
      try {
        await this.$server.put(`/endMoldWork/${this.activeMold.id}`);
        this.activeMold = null;
        this.selectedMoldId = '';
        this.moldSearchText = '';
      } catch (e) {
        alert('작업 종료에 실패했습니다.');
        console.error(e);
      }
    },
    goProductionOrderPage() {
      this.showOrderModal = false;
      this.$router.push({ name: "ProductionOrderList" });
    },
    goWorkConditionPage() {
      this.showOrderModal = false;
      this.$router.push({ name: "WorkConditionList" });
    },
    openTodayOrderModal() {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const dd = String(today.getDate()).padStart(2, "0");
      const todayStr = `${yyyy}-${mm}-${dd}`;

      this.showOrderModal = true;
      this.orderLoading = true;
      this.orderNotFound = false;
      this.orderPost = { workDate: "", insertTime: "", boardRemark: "", items: [] };

      this.$server
        .get("/getOrderList", {
          params: { page: 0, size: 1, searchField: "WORK_DATE", searchKeyword: todayStr },
        })
        .then((res) => {
          const result = (res.data && res.data.result) || [];
          if (!result.length) {
            this.orderNotFound = true;
            this.orderLoading = false;
            return;
          }
          return this.$server.get(`/getOrder/${result[0].id}`);
        })
        .then((res) => {
          if (!res) return;
          const data = (res.data && res.data.result) || {};
          this.orderPost = {
            workDate: data.workDate || "",
            insertTime: data.insertTime || "",
            boardRemark: data.boardRemark || "",
            items: data.items || [],
          };
          this.orderLoading = false;
        })
        .catch(() => {
          this.orderNotFound = true;
          this.orderLoading = false;
        });
    },
    getData() {
      this.$server.get('/getSensorTolerance')
        .then(res => {
          const data = res.data.result;
          if (data.length === 0) {
            alert('검색된 데이터가 없습니다.');
            this.tableData = [];
            return;
          } 
          this.$store.dispatch("sensor/insertSensor", data);
          this.tableData = data;
          console.log("잘 저장됐나??? 222 : " + this.sensor.FIELD_TEM.useYn);
          const s = this.sensor || {};

          // 현장온도 (FIELD_TEM)
          this.fieldTemMin = s.FIELD_TEM?.minValue ?? 0;
          this.fieldTemLowDanger = s.FIELD_TEM?.lowDangerValue ?? 0;
          this.fieldTemLowWarn   = s.FIELD_TEM?.lowWarnValue ?? 0;
          this.fieldTemWarn = s.FIELD_TEM?.warnValue ?? 0;
          this.fieldTemDanger = s.FIELD_TEM?.dangerValue ?? 0;
          this.fieldTemMax = s.FIELD_TEM?.maxValue ?? 0;
          this.fieldTemUseYn = s.FIELD_TEM?.useYn ?? 'Y';

          // 현장습도 (FIELD_HUM)
          this.fieldHumMin = s.FIELD_HUM?.minValue ?? 0;
          this.fieldHumLowDanger = s.FIELD_HUM?.lowDangerValue ?? 0;
          this.fieldHumLowWarn   = s.FIELD_HUM?.lowWarnValue ?? 0;
          this.fieldHumWarn = s.FIELD_HUM?.warnValue ?? 0;
          this.fieldHumDanger = s.FIELD_HUM?.dangerValue ?? 0;
          this.fieldHumMax = s.FIELD_HUM?.maxValue ?? 0;
          this.fieldHumUseYn = s.FIELD_HUM?.useYn ?? 'Y';

          // 압출온도 (EXTRUSION)
          this.extrusionMin = s.EXTRUSION?.minValue ?? 0;
          this.extrusionLowDanger = s.EXTRUSION?.lowDangerValue ?? 0;
          this.extrusionLowWarn   = s.EXTRUSION?.lowWarnValue ?? 0;
          this.extrusionWarn = s.EXTRUSION?.warnValue ?? 0;
          this.extrusionDanger = s.EXTRUSION?.dangerValue ?? 0;
          this.extrusionMax = s.EXTRUSION?.maxValue ?? 0;
          this.extrusionUseYn = s.EXTRUSION?.useYn ?? 'Y';

          // 퀜칭온도1 (QUENCHING_1)
          this.quenching1Min = s.QUENCHING_1?.minValue ?? 0;
          this.quenching1LowDanger = s.QUENCHING_1?.lowDangerValue ?? 0;
          this.quenching1LowWarn   = s.QUENCHING_1?.lowWarnValue ?? 0;
          this.quenching1Warn = s.QUENCHING_1?.warnValue ?? 0;
          this.quenching1Danger = s.QUENCHING_1?.dangerValue ?? 0;
          this.quenching1Max = s.QUENCHING_1?.maxValue ?? 0;
          this.quenching1UseYn = s.QUENCHING_1?.useYn ?? 'Y';

          // 퀜칭온도2 (QUENCHING_2)
          this.quenching2Min = s.QUENCHING_2?.minValue ?? 0;
          this.quenching2LowDanger = s.QUENCHING_2?.lowDangerValue ?? 0;
          this.quenching2LowWarn   = s.QUENCHING_2?.lowWarnValue ?? 0;
          this.quenching2Warn = s.QUENCHING_2?.warnValue ?? 0;
          this.quenching2Danger = s.QUENCHING_2?.dangerValue ?? 0;
          this.quenching2Max = s.QUENCHING_2?.maxValue ?? 0;
          this.quenching2UseYn = s.QUENCHING_2?.useYn ?? 'Y';

          // 퀜칭온도3 (QUENCHING_3)
          this.quenching3Min = s.QUENCHING_3?.minValue ?? 0;
          this.quenching3LowDanger = s.QUENCHING_3?.lowDangerValue ?? 0;
          this.quenching3LowWarn   = s.QUENCHING_3?.lowWarnValue ?? 0;
          this.quenching3Warn = s.QUENCHING_3?.warnValue ?? 0;
          this.quenching3Danger = s.QUENCHING_3?.dangerValue ?? 0;
          this.quenching3Max = s.QUENCHING_3?.maxValue ?? 0;
          this.quenching3UseYn = s.QUENCHING_3?.useYn ?? 'Y';

          // 스트레칭 (STRETCHING)
          this.stretchingMin = s.STRETCHING?.minValue ?? 0;
          this.stretchingLowDanger = s.STRETCHING?.lowDangerValue ?? 0;
          this.stretchingLowWarn   = s.STRETCHING?.lowWarnValue ?? 0;
          this.stretchingWarn = s.STRETCHING?.warnValue ?? 0;
          this.stretchingDanger = s.STRETCHING?.dangerValue ?? 0;
          this.stretchingMax = s.STRETCHING?.maxValue ?? 0;
          this.stretchingUseYn = s.STRETCHING?.useYn ?? 'Y';

          // 퀜칭후온도1 (QUENCH_AFTER_1)
          this.quenchAfter1Min = s.QUENCH_AFTER_1?.minValue ?? 0;
          this.quenchAfter1LowDanger = s.QUENCH_AFTER_1?.lowDangerValue ?? 0;
          this.quenchAfter1LowWarn   = s.QUENCH_AFTER_1?.lowWarnValue ?? 0;
          this.quenchAfter1Warn = s.QUENCH_AFTER_1?.warnValue ?? 0;
          this.quenchAfter1Danger = s.QUENCH_AFTER_1?.dangerValue ?? 0;
          this.quenchAfter1Max = s.QUENCH_AFTER_1?.maxValue ?? 0;
          this.quenchAfter1UseYn = s.QUENCH_AFTER_1?.useYn ?? 'Y';

          // 퀜칭후온도2 (QUENCH_AFTER_2)
          this.quenchAfter2Min = s.QUENCH_AFTER_2?.minValue ?? 0;
          this.quenchAfter2LowDanger = s.QUENCH_AFTER_2?.lowDangerValue ?? 0;
          this.quenchAfter2LowWarn   = s.QUENCH_AFTER_2?.lowWarnValue ?? 0;
          this.quenchAfter2Warn = s.QUENCH_AFTER_2?.warnValue ?? 0;
          this.quenchAfter2Danger = s.QUENCH_AFTER_2?.dangerValue ?? 0;
          this.quenchAfter2Max = s.QUENCH_AFTER_2?.maxValue ?? 0;
          this.quenchAfter2UseYn = s.QUENCH_AFTER_2?.useYn ?? 'Y';

          // 퀜칭후온도3 (QUENCH_AFTER_3)
          this.quenchAfter3Min = s.QUENCH_AFTER_3?.minValue ?? 0;
          this.quenchAfter3LowDanger = s.QUENCH_AFTER_3?.lowDangerValue ?? 0;
          this.quenchAfter3LowWarn   = s.QUENCH_AFTER_3?.lowWarnValue ?? 0;
          this.quenchAfter3Warn = s.QUENCH_AFTER_3?.warnValue ?? 0;
          this.quenchAfter3Danger = s.QUENCH_AFTER_3?.dangerValue ?? 0;
          this.quenchAfter3Max = s.QUENCH_AFTER_3?.maxValue ?? 0;
          this.quenchAfter3UseYn = s.QUENCH_AFTER_3?.useYn ?? 'Y';

          // 압출속도 (EXTRUSION_SPEED)
          this.extrusionSpeedMin = s.EXTRUSION_SPEED?.minValue ?? 0;
          this.extrusionSpeedLowDanger = s.EXTRUSION_SPEED?.lowDangerValue ?? 0;
          this.extrusionSpeedLowWarn   = s.EXTRUSION_SPEED?.lowWarnValue ?? 0;
          this.extrusionSpeedWarn = s.EXTRUSION_SPEED?.warnValue ?? 0;
          this.extrusionSpeedDanger = s.EXTRUSION_SPEED?.dangerValue ?? 0;
          this.extrusionSpeedMax = s.EXTRUSION_SPEED?.maxValue ?? 0;
          this.extrusionSpeedUseYn = s.EXTRUSION_SPEED?.useYn ?? 'Y';

          // 퀜칭수위 (QUENCH_LEVEL)
          this.quenchLevelMin = s.QUENCH_LEVEL?.minValue ?? 0;
          this.quenchLevelLowDanger = s.QUENCH_LEVEL?.lowDangerValue ?? 0;
          this.quenchLevelLowWarn   = s.QUENCH_LEVEL?.lowWarnValue ?? 0;
          this.quenchLevelWarn = s.QUENCH_LEVEL?.warnValue ?? 0;
          this.quenchLevelDanger = s.QUENCH_LEVEL?.dangerValue ?? 0;
          this.quenchLevelMax = s.QUENCH_LEVEL?.maxValue ?? 0;
          this.quenchLevelUseYn = s.QUENCH_LEVEL?.useYn ?? 'Y';
          this.extrusionSetSpeed = s.EXTRUSION_SET_SPEED?.useYn ?? 0;

          // 압출압력 (EXTRUSION_PRESSURE)
          this.extrusionPressureMin = s.EXTRUSION_PRESSURE?.minValue ?? 0;
          this.extrusionPressureLowDanger = s.EXTRUSION_PRESSURE?.lowDangerValue ?? 0;
          this.extrusionPressureLowWarn   = s.EXTRUSION_PRESSURE?.lowWarnValue ?? 0;
          this.extrusionPressureWarn = s.EXTRUSION_PRESSURE?.warnValue ?? 0;
          this.extrusionPressureDanger = s.EXTRUSION_PRESSURE?.dangerValue ?? 0;
          this.extrusionPressureMax = s.EXTRUSION_PRESSURE?.maxValue ?? 0;
          this.extrusionPressureUseYn = s.EXTRUSION_PRESSURE?.useYn ?? 'Y';

        })
        .catch(err => {
          console.error(`${err.message}`);
        })
    },
    async poll() {
      try {
        this.error = false;

        const http = new XMLHttpRequest();
        http.open('GET', `/landspot/justt.cgi?app=${this.app}`, true);
        http.timeout = 8000;

        http.onreadystatechange = () => {
          if (http.readyState === 4) {
            if (http.status >= 200 && http.status < 300) {
              // console.log("body:", http.responseText);
              if (http.responseText && http.responseText.trim()) {
                this.html = http.responseText;
              }
            } else {
              console.error("XHR error:", http.status);
              this.error = true;
            }

            // ✅ 응답 끝난 후에만 다음 요청 예약
            this.timerId = setTimeout(this.poll, this.pollDelay);
          }
        };

        http.onerror = (e) => {
          console.error("XHR onerror:", e);
          this.error = true;
          this.timerId = setTimeout(this.poll, this.pollDelay);
        };

        http.ontimeout = () => {
          console.error("XHR timeout");
          this.error = true;
          this.timerId = setTimeout(this.poll, this.pollDelay);
        };

        http.send(null);
        this.parsePayload(this.html);

      } catch (e) {
        this.error = true;
        console.error("catch Err:", e);
        // 여기서는 다음 poll 예약 안 함
      }
    },
    parsePayload(html) {
      // 1) HTML 파싱
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // 2) 각 영역 텍스트 추출 (textContent면 <br>도 줄바꿈으로 들어옵니다)
      const targetText  = doc.querySelector('#target')?.textContent || '';
      const ambientText = doc.querySelector('#ambient')?.textContent || '';
      const signalText  = doc.querySelector('#signal')?.textContent || '';

      // 3) 숫자만 뽑는 유틸 (음수/소수 지원)
      const nums = (s) => Array.from(s.matchAll(/-?\d+(?:\.\d+)?/g)).map(m => Number(m[0]));

      // 4) 값 추출
      this.target  = nums(targetText)[0];     // 532.4
      this.ambient = nums(ambientText)[0];    // 38.9
      this.signal = nums(signalText);     // [0.062, 0.058]

      console.log("this.targetText :", this.target);
      console.log("this.ambientText :", this.ambient);
      console.log("this.signalText  :", this.signal);
      console.log("this.signalText 0 :", this.signal[0]);
      console.log("this.signalText 1 :", this.signal[1]);

      // return { this.target, ambient, signal: sigVals };
    },

    // 웹소켓 방 생성
    connect() {
      // 웹소켓 이미 연결되어 있으면 함수 실행 x
      // if (this.roomId === this.currentUser.certKey) return;
      console.log(`소켓 연결을 시도합니다.`)
      const vm = this;
      const serverURL = this.common.wsUrl
      let socket = new SockJS(serverURL);
      this.stomp = Stomp.over(socket, {debug: false});
      console.log(`서버 주소: ${serverURL}`)
      
      this.stomp.connect({}, function () {
        console.log("STOMP Connection")
        // ! 나중에 바꿀 것
        vm.roomId = '1234';
        vm.stomp.subscribe(`/sub/chat/room/${vm.roomId}`, function (res) {
          console.log('구독으로 받은 메시지 입니다.', res.body);
          const body = JSON.parse(res.body)
          const msg = JSON.parse(body.message)

          vm.fieldTem = msg.fieldTem;
          vm.fieldHum = msg.fieldHum;
          vm.extrusion = msg.extrusion;
          vm.quenching1 = msg.quenching1;
          vm.quenching2 = msg.quenching2;
          vm.quenching3 = msg.quenching3;
          vm.stretching = msg.stretching;
          vm.heatTreatRead1 = msg.heatMs.heatTreatRead1;
          vm.heatTreatRead2 = msg.heatMs.heatTreatRead2;
          vm.heatTreatSet1 = msg.heatMs.heatTreatSet1;
          vm.heatTreatSet2 = msg.heatMs.heatTreatSet2;
          vm.quenchAfter1 = msg.quenchAfter1;
          vm.quenchAfter2 = msg.quenchAfter2;
          vm.quenchAfter3 = msg.quenchAfter3;
          vm.quenchLevel = msg.quenchLevel;
          vm.billetPreheatRead1 = msg.billetPre.read1;
          vm.billetPreheatRead2 = msg.billetPre.read2;
          vm.billetPreheatRead3 = msg.billetPre.read3;
          vm.billetPreheatRead4 = msg.billetPre.read4;
          vm.billetPreheatSet1 = msg.billetPre.set1;
          vm.billetPreheatSet2 = msg.billetPre.set2;
          vm.billetPreheatSet3 = msg.billetPre.set3;
          vm.billetPreheatSet4 = msg.billetPre.set4;
          vm.extrusionSetSpeed = msg.extrusionSetSpeed;
          vm.extrusionPressure = msg.extrusionPressure;
          vm.extrusionSpeed = msg.extrusionSpeed;
          vm.billetWork = msg.billetWork;
          vm.doorOpen = msg.doorOpen;
          vm.heatTreatWork = msg.heatTreatWork;

        });
        vm.stomp.send('/pub/chat/enter', JSON.stringify({roomId: vm.roomId}))
        setInterval(() => {
          vm.stomp.send('/pub/chat/enter', JSON.stringify({roomId: vm.roomId}))
        }, 1000)
      }, function (error) {
        console.error('STOMP 연결 실패:', error);
      });
    },
    // 로그아웃시 웹소켓 연결 끊기
    disconnect() {
      const vm = this;
      if (this.stomp.connected) {
        vm.stomp.disconnect();
        console.log('STOMP connection disconnect');
        vm.roomId = null;
      }
    }
  },
  mounted() {
    this.connect();
    this.getData();
    this.loadMoldList();
    this.loadActiveMold();
    this.fetchLampMute();
  },
  beforeDestroy() {
    if (this.timerId) clearTimeout(this.timerId);
  }
};
</script>

<style scoped>
/* =========================================================
  Elegant Lavender Dashboard (CSS ONLY)
  - 6-col grid 기반 span 컨트롤
========================================================= */

/* ── 출구온도 경광등 뮤트 버튼 (라벨 텍스트와 같은 줄, 슬롯으로 삽입) ── */
.mute-btn {
  width: 26px;
  height: 26px;
  padding: 3px;
  border: 1px solid #eac5d1;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.15s;
}
.mute-btn:hover { background: #ffebf1; }
.mute-btn img { width: 100%; height: 100%; object-fit: contain; display: block; }

/* ---- Theme tokens ---- */
:root {
  --bg-0: #fbf6f8;
  --bg-1: #faeff3;
  --surface: rgba(255, 255, 255, 0.72);
  --surface-solid: #ffffff;
  --border: rgba(17, 24, 39, 0.08);
  --text: #111827;
  --muted: rgba(17, 24, 39, 0.62);

  --purple: #ed3a73;
  --purple-2: #f75585;
  --purple-soft: rgba(237, 58, 115, 0.14);
  --purple-soft-2: rgba(247, 85, 133, 0.12);

  --radius: 18px;
  --radius-lg: 22px;

  --shadow: 0 14px 36px rgba(17, 24, 39, 0.10);
  --shadow-soft: 0 10px 24px rgba(17, 24, 39, 0.07);
  --shadow-hover: 0 18px 44px rgba(17, 24, 39, 0.14);
}

/* ---- Page background ---- */
.home {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background:
    radial-gradient(1100px 600px at 15% 5%, rgba(247, 85, 133, 0.16), transparent 55%),
    radial-gradient(900px 520px at 85% 10%, rgba(237, 58, 115, 0.14), transparent 55%),
    linear-gradient(180deg, var(--bg-1), var(--bg-0));
}

/* ---- Layout container: wider usage ---- */
.totalWrap {
  max-width: 2230px;
  width: 100%;
  margin: 0 auto;
  padding: 18px 10px 46px;
  box-sizing: border-box;
}

/* ---- Header ---- */
.headText {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 18px 0 26px;
}

.headText > p {
  margin: 0;
  font-size: 40px;
  font-weight: 900;
  letter-spacing: -0.8px;
  color: #000;
}

/* =========================================================
  Sections (6-col grid)
========================================================= */
.topSection,
.lowerSection {
  display: grid;
  gap: 20px;
  margin-bottom: 22px;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  align-items: stretch;
}

/* =========================================================
  Grid span rules (요구사항 반영)
========================================================= */
/* TOP: 1 / 2 / 1 / 2 = 총 6칸 */
.topSection .fieldEnv      { grid-column: span 1; display: flex; flex-direction: column; }
.topSection .billetInsert  { grid-column: span 2; display: flex; flex-direction: column; }
.topSection .extrusion     { grid-column: span 1; display: flex; flex-direction: column; }
.topSection .quenching     { grid-column: span 2; display: flex; flex-direction: column; }

.topSection .fieldEnv .gaugeGrid,
.topSection .billetInsert .gaugeGrid,
.topSection .quenching .gaugeGrid {
  margin-top: 90px;
  margin-bottom: auto;
  gap: 28px;
}

.topSection .extrusion .gaugeGrid-1 { gap: 28px; }

/* LOWER: 3 / 1 / 2 = 총 6칸 */
.lowerSection .quenchAfter    { grid-column: span 3; }
.lowerSection .stretching     { grid-column: span 1; }
.lowerSection .heatTreatment  { grid-column: span 2; }

/* =========================================================
  Cards
========================================================= */
.card {
  border-radius: var(--radius-lg);
  padding: 18px 18px 20px;
  box-sizing: border-box;
  min-height: 250px;

  /* background: var(--surface); */
  background: var(--surface);
  border: 1px solid var(--border);

  box-shadow: var(--shadow-soft);

  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
}

.card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-hover);
  border-color: rgba(237, 58, 115, 0.18);
}

/* 상단 카드(보라계열) - 너무 진하지 않게 */
.cardPurple {
  background: #FFF;
    /* linear-gradient(180deg, rgba(255, 255, 255, 0.82), rgba(255, 255, 255, 0.66)),
    radial-gradient(800px 280px at 15% 0%, rgba(247, 85, 133, 0.18), transparent 65%); */
}

/* lower section 동일 톤 유지 */
.lowerSection .card {
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.90), rgba(255, 255, 255, 0.72));
}

/* =========================================================
  Typography
========================================================= */
.title {
  font-size: 22px;
  font-weight: 850;
  margin: 0 0 14px;
  color: var(--text);
  letter-spacing: -0.3px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.title::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: linear-gradient(180deg, var(--purple-2), var(--purple));
  box-shadow: 0 0 0 6px var(--purple-soft);
  flex: 0 0 auto;
}

.valueTxt {
  font-size: 13px;
  margin: 0 0 8px;
  color: var(--muted);
}

/* =========================================================
  Gauge Layout
========================================================= */
.gaugeGrid {
  display: grid;
  gap: 14px;
  align-items: center;
  justify-items: center;
}

.gaugeGrid-1 { grid-template-columns: 1fr; }
.gaugeGrid-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.gaugeGrid-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }

.gaugeItem {
  width: 100%;
  max-width: 270px;
  display: flex;
  justify-content: center;
}

.gaugeGrid .gaugeItem {
  padding: 2px 0;
}

/* heat list */
.heatList {
  display: flex;
  justify-content: center;
  text-align: center;
  align-content: center;
  align-items: center;
  margin-top: 10px;
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(237, 58, 115, 0.06);
  border: 1px solid rgba(237, 58, 115, 0.10);
}

.heatListChild {
  margin-top: 10px;
  /* display: flex;
  justify-content: center; */
}
.heatTreatSetting {
  height: 170px;
  width: 120px;
  text-align: center;
  align-content: center;
  margin-top: 10px;
  /* margin-right: 20px; */
  margin-bottom: 10px;
  border: #ffdce8 1px solid;
  background: #FFF;
  border-radius: 10px;
}
.heatTreatReadTop {
  display: flex;
  justify-content: center;
}

.heatTreatReadBottom {
  display: flex;
  justify-content: center;
}

.heatTreatValue {
  height: 80px;
  width: 110px;
  text-align: center;
  align-content: center;
  margin-left: 10px;
  margin-bottom: 10px;
  border: #ffdce8 1px solid;
  background: #FFF;
  border-radius: 10px;
}

.valuePoint {
  font-size: 16pt;
  font-weight: 600;
}
.workState {
  font-size: 14pt;
  font-weight: 800;
}

.crtData {
  text-align: center;
}

/* ---- 금형 작업 컨트롤 ---- */
.moldControl {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  justify-self: end;
}

.moldControl-inner {
  display: flex;
  align-items: center;
  gap: 8px;
}

.moldComboWrap {
  position: relative;
  min-width: 260px;
}

.moldInput {
  width: 100%;
  height: 48px;
  padding: 0 14px;
  border: 1px solid #feb4ca;
  border-radius: 8px;
  background: #fff5f8;
  color: #8a2d4b;
  font-size: 20px;
  font-weight: 600;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
}

.moldInput:focus {
  border-color: #ed3a73;
  background: #fff;
}

.moldInput:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #fee9f0;
}

.moldDropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #feb4ca;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(237, 58, 115, 0.12);
  list-style: none;
  margin: 0;
  padding: 4px 0;
  z-index: 9000;
  max-height: 220px;
  overflow-y: auto;
}

.moldDropdown-item {
  padding: 10px 14px;
  font-size: 20px;
  color: #374151;
  cursor: pointer;
  transition: background 0.1s;
}

.moldDropdown-item:hover,
.moldDropdown-item--selected {
  background: #fff0f5;
  color: #ed3a73;
  font-weight: 700;
}

.moldDropdown-empty {
  padding: 10px 12px;
  font-size: 13px;
  color: #9ca3af;
  text-align: center;
}

.moldBtns {
  display: flex;
  gap: 6px;
}

.moldBtn {
  height: 48px;
  padding: 0 22px;
  border: none;
  border-radius: 8px;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
  white-space: nowrap;
}

.moldBtn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.moldBtn-start {
  background: #5c0427;
  color: #fff;
}

.moldBtn-start:not(:disabled):hover {
  background: linear-gradient(120deg, #d92860, #951d43);
}

.moldBtn-end {
  background: linear-gradient(120deg, #dc2626, #b91c1c);
  color: #fff;
}

.moldBtn-end:not(:disabled):hover {
  background: linear-gradient(120deg, #b91c1c, #991b1b);
}

.activeMoldBadge {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f0fdf4;
  border: 1px solid #86efac;
  border-radius: 20px;
  padding: 5px 16px;
}

.activeMoldDot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #16a34a;
  animation: moldPulse 1.4s infinite;
  flex-shrink: 0;
}

@keyframes moldPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}

.activeMoldText {
  font-size: 18px;
  font-weight: 700;
  color: #15803d;
  white-space: nowrap;
}

.todayOrder {
  display: inline-flex;
  align-items: center;
  padding: 8px 18px;
  cursor: pointer;
  justify-self: start;
  background: #fff0f5;
  border: 1px solid #feb4ca;
  border-radius: 6px;
  user-select: none;
  transition: background 0.15s;
}

.todayOrder:hover {
  background: #fee9f0;
}

.todayOrder-text {
  font-size: 20px;
  font-weight: 600;
  color: #ed3a73;
  white-space: nowrap;
}

.todayOrder:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(220, 160, 179, 0.3);
}

/* ---- 금일 생산지시서 모달 ---- */
.order-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.order-modal {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
  width: 92vw;
  max-width: 1400px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.order-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px 14px;
  border-bottom: 1px solid #f8e9ee;
  flex-shrink: 0;
}

.order-modal-title {
  font-size: 18px;
  font-weight: 800;
  color: #653d4a;
}

.order-modal-close {
  background: none;
  border: none;
  font-size: 18px;
  color: #888;
  cursor: pointer;
  line-height: 1;
}

.order-modal-close:hover {
  color: #333;
}

.order-modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 18px 24px;
}

.order-modal-loading,
.order-modal-empty {
  text-align: center;
  padding: 60px 0;
  color: #888;
  font-size: 16px;
}

.order-info-row {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.order-info-box {
  background: #fff4f7;
  border: 1px solid #ffd4e2;
  border-radius: 10px;
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.order-info-label {
  font-size: 15px;
  font-weight: 700;
  color: #946573;
}

.order-info-value {
  font-size: 17px;
  font-weight: 700;
  color: #222;
}

.order-table-wrap {
  width: 100%;
  overflow-x: auto;
  border-radius: 10px;
}

.order-table {
  width: 100%;
  min-width: 1500px;
  border-collapse: separate;
  border-spacing: 0;
  text-align: center;
  font-size: 17px;
}

.order-table thead {
  background: linear-gradient(90deg, #b84f64, #b0415e);
  color: #fff;
}

.order-table thead th {
  padding: 10px 8px;
  font-size: 20px;
  font-weight: 700;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.order-table tbody td {
  padding: 8px 12px;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #eee;
  background: #fff;
  white-space: nowrap;
}

.order-table tbody tr:nth-child(odd) td {
  background: #fef7f9;
}

.order-empty-row {
  padding: 30px 0 !important;
  color: #777;
  font-weight: 600;
}

.order-remark-box {
  margin-top: 14px;
  background: #fafafa;
  border: 1px solid #f5e8ec;
  border-radius: 10px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.order-remark-label {
  font-size: 20px;
  font-weight: 800;
  color: #653d4a;
}

.order-remark-text {
  font-size: 17px;
  color: #333;
  white-space: pre-wrap;
  line-height: 1.6;
}

.order-modal-footer {
  padding: 14px 24px;
  border-top: 1px solid #f8e9ee;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

.order-go-btn {
  background: linear-gradient(120deg, #b84f64, #b0415e);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 22px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  margin-left: 20px;
}

.order-go-btn:hover {
  background: #5c0427;
}
/* =========================================================
  Responsive (span 안정화)
========================================================= */

/* 1600px 이하: 6col → 3col (span 단순화: 모두 1칸) */
@media (max-width: 1600px) {
  .topSection,
  .lowerSection {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .topSection .fieldEnv,
  .topSection .billetInsert,
  .topSection .extrusion,
  .topSection .quenching,
  .lowerSection .quenchAfter,
  .lowerSection .stretching,
  .lowerSection .heatTreatment {
    grid-column: span 1;
  }

  /* 3개 게이지는 2열로 줄여 안정 */
  .gaugeGrid-3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  /* ✅ 열처리 전체: 설정값(1줄) + 아래 2열 리스트 */
  .heatList {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    align-items: start;
    justify-content: unset;
  }

  /* ✅ 설정값은 맨 위에서 2칸 전부 차지 */
  .heatTreatSetting {
    grid-column: 1 / -1;
    width: 100%;
    height: auto;
    margin: 0;
  }

  /* ✅ 아래 6개 값은 2열 grid */
  .heatListChild {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-top: 0;
  }

  /* 기존 top/bottom 래퍼는 흐름만 유지 (flex 제거) */
  .heatTreatReadTop,
  .heatTreatReadBottom {
    display: contents !important;
  }

  /* 카드 스타일 정리 */
  .heatTreatValue {
    width: 100%;
    height: auto;
    margin: 0;
  }

  /* ✅ 재배치 순서: 1,4,2,5,3,6 */
  .heatTreatReadTop .heatTreatValue:nth-child(1) { order: 1; } /* 1 */
  .heatTreatReadBottom .heatTreatValue:nth-child(1) { order: 2; } /* 4 */
  .heatTreatReadTop .heatTreatValue:nth-child(2) { order: 3; } /* 2 */
  .heatTreatReadBottom .heatTreatValue:nth-child(2) { order: 4; } /* 5 */
  .heatTreatReadTop .heatTreatValue:nth-child(3) { order: 5; } /* 3 */
  .heatTreatReadBottom .heatTreatValue:nth-child(3) { order: 6; } /* 6 */
}

/* 1200px 이하: 3col → 2col */
@media (max-width: 1200px) {
  .topSection,
  .lowerSection {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .totalWrap {
    padding: 16px 18px 40px;
  }

  .headText > p {
    font-size: 34px;
  }

  .gaugeGrid-3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  /* ✅ 열처리 전체: 설정값(1줄) + 아래 2열 리스트 */
  .heatList {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    align-items: start;
    justify-content: unset;
  }

  /* ✅ 설정값은 맨 위에서 2칸 전부 차지 */
  .heatTreatSetting {
    grid-column: 1 / -1;
    width: 100%;
    height: auto;
    margin: 0;
  }

  /* ✅ 아래 6개 값은 2열 grid */
  .heatListChild {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-top: 0;
  }

  /* 기존 top/bottom 래퍼는 흐름만 유지 (flex 제거) */
  .heatTreatReadTop,
  .heatTreatReadBottom {
    display: contents !important;
  }

  /* 카드 스타일 정리 */
  .heatTreatValue {
    width: 100%;
    height: auto;
    margin: 0;
  }

  /* ✅ 재배치 순서: 1,4,2,5,3,6 */
  .heatTreatReadTop .heatTreatValue:nth-child(1) { order: 1; } /* 1 */
  .heatTreatReadBottom .heatTreatValue:nth-child(1) { order: 2; } /* 4 */
  .heatTreatReadTop .heatTreatValue:nth-child(2) { order: 3; } /* 2 */
  .heatTreatReadBottom .heatTreatValue:nth-child(2) { order: 4; } /* 5 */
  .heatTreatReadTop .heatTreatValue:nth-child(3) { order: 5; } /* 3 */
  .heatTreatReadBottom .heatTreatValue:nth-child(3) { order: 6; } /* 6 */
}

/* 720px 이하: 전부 1열 */
@media (max-width: 720px) {
  .topSection,
  .lowerSection {
    grid-template-columns: 1fr;
  }

  .gaugeGrid-2,
  .gaugeGrid-3 {
    grid-template-columns: 1fr;
  }

  .headText {
    padding: 14px 0 18px;
  }

  .headText > p {
    font-size: 28px;
  }

  .card {
    padding: 16px 14px 18px;
    border-radius: 18px;
  }

  .gaugeItem {
    max-width: 320px;
  }
}
</style>